<template>
  <div id="nav" class="nav">
    <Slide right :closeOnNavigation="true" noOverlay class="slide">
      <router-link to="/">Home</router-link>
      <router-link to="/videos">Videos</router-link>
    </Slide>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'  // import the CSS transitions you wish to use, in this case we are using `Slide`
// import Slide from 'vue-burger-menu'
export default {
  name: 'Nav',
  components: {
    Slide // Register your component
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  #nav {
    z-index: 100000;
    position: relative;
    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #4C7236;
      }
    }
    .slide{
      .bm-menu {
        background-color: white;
      }
      .bm-cross-button{
        left: 10px;
        z-index: 100000;
      }
      .line-style {
        height: 12%;
      }
      .bm-burger-bars {
        background-color: #4C7236;
      }
    }


  }
</style>


